export function linkDownload(url: string, fileName?: string): void {
    const isSameOrigin = url.startsWith(window.location.origin) || url.startsWith('/');

    if (isSameOrigin) {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = fileName || url.split('/').pop() || 'download';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(() => {
                window.open(url, '_blank');
            });
    }
}
